import { IBuildingProviderContext } from '../../@types/ContextProviderRelated';
import { APP_VERSION, JSON_VERSION } from '../../utils/constants';
import Entity, { IEntity } from '../abstract/Entity';

export interface IPlan extends IEntity {
  name: string;
  id: number;
  kojeId: number;
  kojeLevel: number;
  eventId: number;
  dataObjectId: number;
  appVersion: string;
  showroomId: number;
  building: IBuildingProviderContext;
  jsonVersion: string;
  region: string;
}

class PlanModel extends Entity implements IPlan {
  name: string;

  id: number;

  kojeId: number;

  kojeLevel: number;

  eventId: number;

  dataObjectId: number;

  appVersion: string;

  showroomId: number;

  building: IBuildingProviderContext;

  jsonVersion: string;

  region: string;

  constructor(
    name: string = '',
    id: number = -1,
    kojeId: number = -1,
    kojeLevel: number = -1,
    eventId: number = -1,
    dataObjectId: number = -1,
    showroomId: number = -1,
    appVersion: string = APP_VERSION,
    building: IBuildingProviderContext,
    jsonVersion: string = JSON_VERSION,
    region: string = '',
  ) {
    super();
    this.name = name;
    this.id = id;
    this.kojeId = kojeId;
    this.kojeLevel = kojeLevel;
    this.eventId = eventId;
    this.dataObjectId = dataObjectId;
    this.showroomId = showroomId;
    this.appVersion = appVersion;
    this.building = building;
    this.jsonVersion = jsonVersion;
    this.region = region;
  }

  getBuilding(): IBuildingProviderContext {
    return this.building;
  }

  setBuilding(value: IBuildingProviderContext): void {
    this.building = value;
  }

  getName(): string {
    return this.name;
  }

  setName(value: string): void {
    this.name = value;
  }

  getId(): number {
    return this.id;
  }

  setId(value: number): void {
    this.id = value;
  }

  getAppVersion(): string {
    return this.appVersion;
  }

  setAppVersion(value: string): void {
    this.appVersion = value;
  }

  getEventId(): number {
    return this.eventId;
  }

  setEventId(value: number): void {
    this.eventId = value;
  }

  getJsonVersion(): string {
    return this.jsonVersion;
  }

  setJsonVersion(value: string): void {
    this.jsonVersion = value;
  }

  getKojeId(): number {
    return this.kojeId;
  }

  setKojeId(value: number): void {
    this.kojeId = value;
  }

  getKojeLevel(): number {
    return this.kojeLevel;
  }

  setKojeLevel(value: number): void {
    this.kojeLevel = value;
  }

  getShowroomId(): number {
    return this.showroomId;
  }

  setShowroomId(value: number): void {
    this.showroomId = value;
  }

  getDataObjectId(): number {
    return this.dataObjectId;
  }

  setDataObjectId(value: number): void {
    this.dataObjectId = value;
  }

  getRegion(): string {
    return this.region;
  }

  setRegion(value: string): void {
    this.region = value;
  }

  // Convert instance to JSON
  toJSON() {
    return {
      ...super.toJSON(),
      plan: {
        name: this.name,
        id: this.id,
        kojeId: this.kojeId,
        kojeLevel: this.kojeLevel,
        eventId: this.eventId,
        dataObjectId: this.dataObjectId,
        showroomId: this.showroomId,
        appVersion: this.appVersion,
        building: this.building,
        jsonVersion: this.jsonVersion,
        region: this.region,
      },
    };
  }

  // Create instance from JSON
  fromJSON(jsonString: string): PlanModel {
    const data = JSON.parse(jsonString);
    return new PlanModel(
      data.plan?.name ?? '',
      data.plan?.id ?? -1,
      data.plan?.kojeId ?? -1,
      data.plan?.kojeLevel ?? -1,
      data.plan?.eventId ?? -1,
      data.plan?.dataObjectId ?? -1,
      data.plan?.showroomId ?? -1,
      data.plan?.appVersion ?? APP_VERSION,
      data.plan?.building,
      data.plan?.jsonVersion ?? JSON_VERSION,
      data.plan?.region ?? '',
    );
  }
}

export default PlanModel;
